import { ValuesType } from "./LoginForm.types";
import { FormikHelpers } from "formik";
import { useSignInApi } from "hooks";
import { useCallback, useMemo } from "react";
import { ERRORS, FIELD_NAMES } from "./LoginForm.constants";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "lib/supabaseClient";

export function useInitialState() {
  return useMemo(() => {
    return {
      [FIELD_NAMES.EMAIL]: "",
      [FIELD_NAMES.PASSWORD]: "",
    };
  }, []);
}

export function useSubmitHandler() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { mutateAsync } = useSignInApi({});
  return useCallback(
    async (props: ValuesType, formikHelpers: FormikHelpers<ValuesType>) => {
      formikHelpers.setSubmitting(true);
      const email = props.email.toLowerCase();

      try {
        let result: any;
        try {
          result = await mutateAsync({ email });
        } catch (error: any) {
          const data = error?.response?.data;
          if (data && typeof data === "object") {
            formikHelpers.setErrors(data);
          } else {
            formikHelpers.setErrors({
              [FIELD_NAMES.EMAIL]:
                error?.message ||
                "Couldn't reach the server. Please try again.",
            });
          }
          return;
        }

        if (!result?.data?.userExists) {
          formikHelpers.setErrors({
            [FIELD_NAMES.EMAIL]:
              "We couldn't find an account for that email.",
          });
          return;
        }

        const { error } = await supabase.auth.signInWithPassword({
          email,
          password: props.password,
        });

        if (error) {
          const matchingError = ERRORS.find((item) =>
            error.message.toLowerCase().includes(item.code.toLowerCase())
          );
          if (matchingError) {
            formikHelpers.setErrors({
              [matchingError.field]: matchingError.message,
            });
          } else {
            formikHelpers.setErrors({
              [FIELD_NAMES.EMAIL]: error.message,
            });
          }
          return;
        }

        if (state) {
          navigate((state as any).from);
        }
        window.location.reload();
      } finally {
        formikHelpers.setSubmitting(false);
      }
    },
    [mutateAsync, navigate, state]
  );
}
